export const JANUARY = "Janvier";
export const FEBRUARY = "Février";
export const MARCH = "Mars";
export const APRIL = "Avril";
export const MAY = "Mai";
export const JUNE = "Juin";
export const JULY = "Juillet";
export const AUGUST = "Août";
export const SEPTEMBER = "Septembre";
export const OCTOBER = "Octobre";
export const NOVEMBER = "Novembre";
export const DECEMBER = "Décembre";

export const PRESENT = "Présent";
export const MONTHS = "mois";
export const YEARS = "ans";
